import { useState } from "react"

export default () => {
  const [manageOppOpportunity, setManageOppOpportunity] = useState()
  const [manageOppOpportunityId, setManageOppOpportunityId] = useState()
  const [shipModalsChange, setShipModalsChange] = useState()

  return {
    shipModals: { 
      setManageOppOpportunity, 
      setManageOppOpportunityId,
      shipModalsChange 
    },

    modalState: {
      manageOppOpportunity,
      setManageOppOpportunity,
      manageOppOpportunityId,
      setManageOppOpportunityId,
      setShipModalsChange
    }
  }
}